export default {
  namespaced: true,
  charts_embedder: {
    loading: "Carregando...",
    select_to_begin: "Selecione um dataset e uma visualização para começar.",
    copy: "Copiar",
    apply: "Aplicar",
    settings: "Configurações",
    dataset: "Dataset",
    view: "Visualização",
    language: "Idioma",
    time_range: "Intervalo de tempo",
    custom_date: "Intervalo de datas personalizado",
    from: "De",
    to: "Até",
    select_date: "Selecionar data...",
    advanced_filters: "Filtros avançados",
    live: "Ao vivo",
  },
};
